import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-timeline',
  standalone: true,
  imports: [],
  templateUrl: './process-timeline.component.html',
  styles: ``
})
export class ProcessTimelineComponent {
  @Input() process!: Process;
}
